export const languageCode = 'de';
export const languageLabel = 'German';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Aus',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Untertitelmenü ausblenden',
  CAPTIONS_OFF: 'Aus',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Video suchen',
  CAPTIONS_SHOW_MENU: 'Untertitelmenü anzeigen',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Kapitel schließen',
  CHAPTERS_OPEN_CHAPTERS: 'Kapitel öffnen',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Klicken Sie hier, um den Ton einzuschalten',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Tippen Sie hier, um den Ton einzuschalten',

  CONTEXT_MENU_ABOUT_WISTIA: 'Über Wistia',
  CONTEXT_MENU_COPIED: 'Kopiert!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'Link und Vorschaubild kopieren',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'In Wistia angemeldet',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Video in Wistia öffnen',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Ein Problem melden',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Statistiken in Wistia anzeigen',

  CUSTOMER_LOGO_LOGO: 'Logo',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Vollbild beenden',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'Vollbild',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Video',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Abspielen',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Pause',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Bitte fügen Sie Details hinzu',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Eine auswählen',
  REPORT_A_PROBLEM_DESCRIPTION:
    'Vielen Dank, dass Sie ein Problem gemeldet haben. Wir werden technische Daten über diese Sitzung hinzufügen, um die Problembehebung zu unterstützen. Welche dieser Optionen beschreibt das Problem am besten?',
  REPORT_A_PROBLEM_DISMISS: 'Verwerfen',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'Das Video lässt sich nicht abspielen',
  REPORT_A_PROBLEM_OTHER: 'Andere',
  REPORT_A_PROBLEM_OTHER_CONTEXT: 'Sonstige Details oder Kontexte?',
  REPORT_A_PROBLEM_POOR_QUALITY: 'Das Video hat eine schlechte Qualität',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Problemkategorie',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Problembeschreibung',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Bitte wählen sie eine Kategorie',
  REPORT_A_PROBLEM_SEND: 'Senden',
  REPORT_A_PROBLEM_SENDING: 'Wird gesendet ...',
  REPORT_A_PROBLEM_STUTTER: 'Das Video lässt sich abspielen, stoppt dabei jedoch häufig',

  REWATCH: 'Noch einmal ansehen',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Geschwindigkeit',
  SETTINGS_QUALITY_AUTO: 'Auto',
  SETTINGS_QUALITY_TITLE: 'Qualität',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Freigabemenü schließen',
  SHARE_CONTROL_OPEN: 'Freigabemenü öffnen',
  SHARE_COPIED: 'Kopiert!',
  SHARE_DOWNLOAD: 'Herunterladen',
  SHARE_EMAIL: 'E-Mail',
  SHARE_EMBED: 'Einbetten',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Überspringen',

  STATUS_BAR_EMBED_CODE_COPIED: 'Einbettungscode ist jetzt in Ihre Zwischenablage kopiert!',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Video-Vorschaubild',

  TURNSTILE_DEFAULT_END: 'Vielen Dank fürs Ansehen! \nBitte geben Sie Ihre E-Mail-Adresse ein.',
  TURNSTILE_DEFAULT_START: 'Geben Sie Ihre E-Mail-Adresse ein um das Video anzusehen.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'Ihre E-Mail-Adresse',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Vorname',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Nachname',
  TURNSTILE_PLAY: 'Abspielen',
  TURNSTILE_SUBMIT: 'Abschicken',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Lautstärkeregler',
  VOLUME_TITLE_WHEN_MUTED: 'Stummschalten beenden',
  VOLUME_TITLE_WHEN_UNMUTED: 'Stummschalten',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'Das nächste Video beginnt in...',
};
